module.exports = "https://cdn.hellotech.com/client-assets/computers_mobile_51160bee7083f64119e40596b968fb64.png";